import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface TutorialVideoResource {
  statusCode: number;
  screenId: string;
  contentType: string;
  signedUrl: string;
  expiresIn: number;
}

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class TutorialVideoService {
  private readonly projectUrl = environment?.baseApiUrl + environment?.projectApiPath;

  constructor(private readonly http: HttpClient) {}

  getTutorialVideoUrl(screenId: string): Observable<TutorialVideoResource> {
    const url = `${this.projectUrl}tutorialVideoUrl${environment?.proxy}?screenId=${encodeURIComponent(screenId)}`;
    return this.http.get(url, { ...httpOptions, responseType: 'text' }).pipe(
      map((response: string) => this.extractTutorialVideoResult(response, screenId))
    );
  }

  private extractTutorialVideoResult(response: string, screenId: string): TutorialVideoResource {
    const parsedResponse = this.parseJson(response);
    const parsedBody = this.parseJson(parsedResponse?.body ?? parsedResponse) ?? {};

    return {
      statusCode: Number(parsedResponse?.statusCode ?? parsedBody?.statusCode ?? 0),
      screenId: parsedBody?.screenId ?? screenId,
      contentType: parsedBody?.contentType ?? 'video/mp4',
      signedUrl: parsedBody?.signedUrl ?? parsedResponse?.signedUrl ?? '',
      expiresIn: Number(parsedBody?.expiresIn ?? parsedResponse?.expiresIn ?? 0)
    };
  }

  private parseJson(value: any): any {
    if (typeof value !== 'string') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
}